import React from 'react';
import { ItemStack } from 'components/ItemStack';
import { ILanguage, ISkillGroup } from 'pages/About/About.types';
import { useTranslation } from 'react-i18next';

import { Divider, Typography } from '@mui/material';
import { Box, Paper } from '@mui/material';

interface SkillsProps {
  skills: ISkillGroup;
  languages: ILanguage[];
}

const Skills: React.FunctionComponent<SkillsProps> = ({
  skills,
  languages,
}) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Paper sx={styles.techStackContainer}>
        <Typography variant='h6' sx={{ mb: 2 }}>
          {t('about.techStack.title')}
        </Typography>
        {Object.keys(skills).map((category) => {
          const skillsByCategory = skills[category].map((skill) => skill.name);
          return (
            <Box key={category}>
              <Typography sx={{ mb: 1 }}>{category}</Typography>
              <ItemStack items={skillsByCategory} />
              <Divider sx={{ mb: 1 }} />
            </Box>
          );
        })}
      </Paper>
      <Paper sx={styles.languagesContainer}>
        <Typography variant='h6'>Languages</Typography>
        {languages.map(({ id, icon, language, level }) => (
          <Box key={id} sx={{ my: 2 }}>
            <Typography variant='subtitle1'>
              {icon} {language}
            </Typography>
            <Typography variant='subtitle1' fontWeight='Medium'>
              {level}
            </Typography>
            <Divider />
          </Box>
        ))}
      </Paper>
    </React.Fragment>
  );
};

const styles = {
  languagesContainer: { px: 3, pb: 1, pt: 2, my: 1 },
  techStackContainer: { px: 3, pb: 1, pt: 2, my: 2 },
};

export default Skills;
